import { render, staticRenderFns } from "./confetti.vue?vue&type=template&id=4e684c9f&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e684c9f",
  null
  
)

export default component.exports